// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiMediaUploadMimeType } from '../models/ApiMediaUploadMimeType';
import { HttpFile } from '../http/http';

export class ApiCreateMediaUploadUrlRequest {
    'content_type': ApiMediaUploadMimeType;
    'file_name': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "content_type",
            "baseName": "content_type",
            "type": "ApiMediaUploadMimeType",
            "format": ""
        },
        {
            "name": "file_name",
            "baseName": "file_name",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiCreateMediaUploadUrlRequest.attributeTypeMap;
    }

    public constructor() {
    }
}



